import { useMemo } from "react";
import { useTheme } from "@mui/material";
import { ProgressionBarSeries } from "@components/Chart/highcharts/ProgressionBarChart/types";
import { ComparisonChartData } from "../ComparisonBaseChart";

export const useChartData = (
  data: ComparisonChartData[],
  key1: string,
  label1: string,
  key2?: string,
  label2?: string,
  quoteLabel?: string
): ProgressionBarSeries[] => {
  const theme = useTheme();
  return useMemo(() => {
    const { key1List, key2List, quoteList } = data.reduce(
      (acc, item) => {
        const xValue = Date.UTC(item.year, 0, 1);
        item.quote && acc.quoteList.push([xValue, item.quote ?? null]);
        acc.key1List.push([xValue, (item as any)[key1] ?? null]);
        if (key2) acc.key2List.push([xValue, (item as any)[key2] ?? null]);
        return acc;
      },
      { key1List: [], key2List: [], quoteList: [] } as {
        key1List: [number, number][];
        key2List: [number, number][];
        quoteList: [number, number][];
      }
    );

    return [
      {
        name: label1,
        type: "column",
        data: key1List,
        color: theme.palette.primary.main,
      },
      ...(key2
        ? [
            {
              name: label2,
              type: "column",
              data: key2List,
              color: theme.palette.grey[800],
            },
          ]
        : []),
      ...(quoteList
        ? [
            {
              name: quoteLabel,
              type: "line",
              data: quoteList,
              color: theme.palette.grey[500],
            },
          ]
        : []),
    ];
  }, [data, key1, key2, label1, label2, quoteLabel, theme]);
};
